import { Card } from "primereact/card";

const fmt = (n: any) =>
  `$${Number(n || 0).toLocaleString("en-CA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const SummaryRow = ({
  label,
  value,
  highlight,
  boldLabel,
}: {
  label: string;
  value: string;
  highlight?: boolean;
  boldLabel?: boolean;
}) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "8px",
      padding: "7px 0",
      borderBottom: "1px solid #f0f0f0",
    }}
  >
    <span
      style={{
        color: "#6c757d",
        fontSize: "0.85rem",
        fontWeight: boldLabel ? 700 : 400,
      }}
    >
      {label}:
    </span>
    <span
      style={{
        fontWeight: highlight ? 700 : 500,
        color: highlight ? "#2c3e50" : "#495057",
        fontSize: "0.875rem",
        whiteSpace: "nowrap",
      }}
    >
      {value}
    </span>
  </div>
);

interface GstSummaryCardsProps {
  data: {
    taxable_income_line_101: number;
    non_taxable_line_102: number;
    total_net_after_fees: number;
    gst_collected: number;
    gst_itc: number;
    balance_due: number;
    gst_simple: number;
    simplified_taxable_income_101: number;
  };
  cardClassName?: string;
  totalIncomeLabel?: string;
}

const GstSummaryCards = ({
  data,
  cardClassName = "mb-3 h-full",
  totalIncomeLabel = "Total Income",
}: GstSummaryCardsProps) => (
  <div className="grid">
    <div className="col-12 md:col-6">
      <Card className={cardClassName}>
        <h6 className="mt-0 mb-2" style={{ color: "#495057", fontWeight: 700 }}>General GST</h6>
        <SummaryRow label="Taxable Income (Line 101)" value={fmt(data.taxable_income_line_101)} highlight />
        <SummaryRow label="Non-Taxable Income (Line 102)" value={fmt(data.non_taxable_line_102)} highlight/>
        <SummaryRow label={totalIncomeLabel} value={fmt(data.total_net_after_fees)} highlight/>
        <SummaryRow label="GST Collected (Line 103)" value={fmt(data.gst_collected)} highlight/>
        <SummaryRow label="GST ITC (Line 106)" value={fmt(data.gst_itc)} highlight/>
        <SummaryRow label="Balance Due / Refund" value={fmt(data.balance_due)} highlight />
      </Card>
    </div>
    <div className="col-12 md:col-6">
      <Card className={cardClassName}>
        <h6 className="mt-0 mb-2" style={{ color: "#495057", fontWeight: 700 }}>Simplified GST</h6>
        <SummaryRow label="GST Simple (3.6%)" value={fmt(data.gst_simple)} highlight boldLabel />
        <SummaryRow label="Taxable Income (Line 101)" value={fmt(data.simplified_taxable_income_101)} highlight />
        <SummaryRow label="Non-Taxable Income (Line 102)" value={fmt(data.non_taxable_line_102)} highlight/>
        <SummaryRow label="GST Collected (Line 103)" value={fmt(data.gst_simple)} highlight/>
      </Card>
    </div>
  </div>
);

export default GstSummaryCards;
